class HigiaStorageSevice {
    itensSessionStorage = ['refresh_token', 'access_token']

    public set = (key: any, value: any, isObj?: boolean) => {
        value = isObj ? JSON.stringify(value) : value
        localStorage.setItem(key, value)
    }

    public get = (key: string, isObj?: boolean) => {
        if (isObj) {
            return JSON.parse(localStorage.getItem(key)!)
        }
        return localStorage.getItem(key)
    }

    public remove = (key: string) => {
        localStorage.removeItem(key)
    }

    public getCookie = (cookieName: string) => {
        if (!this.isDevMode() && this.itensSessionStorage.indexOf(cookieName) >= 0) {
            return sessionStorage.getItem(cookieName)
        }

        const cookiesTemp = document.cookie
        const cookiesList: string[] = cookiesTemp.split(';')
        let i = 0

        const cookiesMap = new Map()
        while (cookiesList[i]) {
            cookiesList[i] = cookiesList[i].trim()
            cookiesMap.set(cookiesList[i].split('=')[0], cookiesList[i].split('=')[1])
            i++
        }

        return cookiesMap.get(cookieName) ? cookiesMap.get(cookieName) : null
    }

    public setCookie = (cookieKey: string, cookieValue: string, expires: Date) => {
        if (!this.isDevMode() && this.itensSessionStorage.indexOf(cookieKey) >= 0) {
            sessionStorage.setItem(cookieKey, cookieValue)
        } else {
            document.cookie = cookieKey + '=' + cookieValue + ';expires=' + expires + ';path=/;'
        }
    }

    isDevMode() {
        if (window.location.href.indexOf('localhost') >= 0) {
            return true
        } else {
            return false
        }
    }
}

export { HigiaStorageSevice }
export default HigiaStorageSevice
